import { render } from "./dropzone.vue?vue&type=template&id=0a2e836c&scoped=true&ts=true"
import script from "./dropzone.vue?vue&type=script&lang=ts"
export * from "./dropzone.vue?vue&type=script&lang=ts"

import "./style.scss?vue&type=style&index=0&id=0a2e836c&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a2e836c"]])

export default __exports__